// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { Device, IDevice } from "./Device.gen";
import { Vector2, IVector2 } from "./System.Numerics.Vector2.gen";

export interface IVisualizerProject {
	device: IDevice | undefined;

	cameraAoiPoints: IVector2[] | undefined;

	homographySourcePoints: IVector2[] | undefined;

	homographyDestinationPoints: IVector2[] | undefined;

	boundaryPoints: IVector2[] | undefined;

	id: string | undefined;

	deviceId: string | undefined;

	facilityId: string | undefined;

	userId: string | undefined;

	name: string | undefined;

	created: string | undefined;

	videoStartDate: string | undefined;

	radarStartDate: string | undefined;

	videoFps: number | undefined;

	inferrenceJsonFile: string | undefined;

	videoFile: string | undefined;

	userResultsJsonFile: string | undefined;

	simResultsJsonFile: string | undefined;

	radarDataBinaryFile: string | undefined;

	deviceSettingsJsonFile: string | undefined;

	trackerConfig: string | undefined;

	useIntrinsicTranslation: boolean;

	estimatedReturnHeight: number;

	devicePositionX: number;

	devicePositionY: number;

	deviceHeight: number;

	deviceHeadingDegrees: number;

	deviceTiltDegrees: number;

	deviceRollDegrees: number;

	$type?: string | undefined;
}
export class VisualizerProject {
	constructor(data?: IVisualizerProject) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.device) { this.device = new Device(data.device); }
		this.cameraAoiPoints = data.cameraAoiPoints ? data.cameraAoiPoints.map((c: any) => new Vector2(c)) : [];
		this.homographySourcePoints = data.homographySourcePoints ? data.homographySourcePoints.map((h: any) => new Vector2(h)) : [];
		this.homographyDestinationPoints = data.homographyDestinationPoints ? data.homographyDestinationPoints.map((h: any) => new Vector2(h)) : [];
		this.boundaryPoints = data.boundaryPoints ? data.boundaryPoints.map((b: any) => new Vector2(b)) : [];
		if (data.created) { this.created = new Date(data.created); }
		if (data.videoStartDate) { this.videoStartDate = new Date(data.videoStartDate); }
		if (data.radarStartDate) { this.radarStartDate = new Date(data.radarStartDate); }
	}

	device: Device | undefined;

	cameraAoiPoints: Vector2[] | undefined = [];

	homographySourcePoints: Vector2[] | undefined = [];

	homographyDestinationPoints: Vector2[] | undefined = [];

	boundaryPoints: Vector2[] | undefined = [];

	id: string | undefined;

	deviceId: string | undefined;

	facilityId: string | undefined;

	userId: string | undefined;

	name: string | undefined;

	created: Date | undefined;

	videoStartDate: Date | undefined;

	radarStartDate: Date | undefined;

	videoFps: number | undefined;

	inferrenceJsonFile: string | undefined;

	videoFile: string | undefined;

	userResultsJsonFile: string | undefined;

	simResultsJsonFile: string | undefined;

	radarDataBinaryFile: string | undefined;

	deviceSettingsJsonFile: string | undefined;

	trackerConfig: string | undefined;

	useIntrinsicTranslation: boolean = false;

	estimatedReturnHeight: number = 0;

	devicePositionX: number = 0;

	devicePositionY: number = 0;

	deviceHeight: number = 0;

	deviceHeadingDegrees: number = 0;

	deviceTiltDegrees: number = 0;

	deviceRollDegrees: number = 0;

	static $type: string = "CoreApi.Models.Visualizer.VisualizerProject, ";
	$type?: string | undefined = VisualizerProject.$type;
}

